import { sequence2vgswtrxvqoa7 as sequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { nullElement39ujy5fzowmto as nullElement } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  DataClassPath2zx7tvblx35e3 as DataClassPath,
  DataClassPathNotNull3k4t7brymixty as DataClassPathNotNull,
  DataClassPathAccess3qupo9g6dhbeb as DataClassPathAccess,
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_serializableProperties1162nosnaangd as get_serializableProperties,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function walkDataClassPathsLimitedRecursion(_this__u8e3s4, serializer) {
  return sequence(walkDataClassPathsLimitedRecursion$slambda(serializer, _this__u8e3s4));
}
function *invoke$recurse(_this__u8e3s4, seen, on, $completion) {
  yield* _this__u8e3s4.yield_3xhcex_k$(on, $completion);
  var tmp0_elvis_lhs = nullElement(on.get_serializer_u29zhh_k$());
  var ser = tmp0_elvis_lhs == null ? on.get_serializer_u29zhh_k$() : tmp0_elvis_lhs;
  var tmp;
  if (ser.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$()) {
    tmp = new (DataClassPathNotNull())(on instanceof DataClassPath() ? on : THROW_CCE());
  } else {
    tmp = on instanceof DataClassPath() ? on : THROW_CCE();
  }
  var basis = tmp;
  var tmp1_safe_receiver = get_serializableProperties(ser);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (seen.add_utx5q5_k$(element)) {
        yield* invoke$recurse(_this__u8e3s4, seen, new (DataClassPathAccess())(basis, isInterface(element, SerializableProperty()) ? element : THROW_CCE()), $completion);
      }
    }
  }
  return Unit_instance;
}
function walkDataClassPathsLimitedRecursion$slambda($serializer, $this_walkDataClassPathsLimitedRecursion) {
  return constructCallableReference(($this$sequence, $completion) => orPromise($completion, function *($completion) {
    var seen = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
    var s = new (DataClassPathSelf())($serializer);
    var indexedObject = $this_walkDataClassPathsLimitedRecursion;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      yield* /*#__NOINLINE__*/invoke$recurse($this$sequence, seen, new (DataClassPathAccess())(s, item), $completion);
    }
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  walkDataClassPathsLimitedRecursion as walkDataClassPathsLimitedRecursion3lpv95ik1iqnu,
};
//endregion

//# sourceMappingURL=propertyTraversal.mjs.map
